import { Link } from 'react-router-dom';
import { featuredWorks } from '@/mocks/home';

export default function WorksSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              精选作品
            </h2>
            <p className="text-foreground-500 text-sm">水野朝阳代表作品一览</p>
          </div>
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {featuredWorks.map((work) => (
            <Link
              key={work.id}
              to={`/article/${work.id}`}
              className="group block"
            >
              <div className="relative overflow-hidden rounded-xl aspect-[3/4] mb-3">
                <div
                  className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                  style={{ backgroundImage: `url(${work.image})` }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
                <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 bg-background-50/90 rounded-full text-xs font-medium text-foreground-800">
                  <i className="ri-star-fill text-accent-500 text-xs" />
                  {work.rating}
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <span className="inline-block px-2 py-0.5 text-xs bg-accent-500/80 text-background-50 rounded-full mb-1.5">
                    {work.category}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1">
                {work.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">{work.year}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}